import React from "react";
import "./styles.scss";

const CategoryCard = (props) => {
  return (
    <>
      <div
        className={`hne-ad-category-card-wrapper ${
          props.isSelect ? "active" : ""
        }`}
      >
        <div className="accw-id">{props.id}</div>
        <div className="accw-category">{props.category}</div>
        <div className="accw-subcategory">{props.subcategory}</div>
        <div className="accw-edit" onClick={props.onClick}>
          {props.edit}
        </div>
      </div>
    </>
  );
};
export default CategoryCard;
